import { ChartValue } from "./ChartValue";

const BAR_WIDTH = 0.7;

export class BarChart {

    public create(values: ChartValue[], showValues: boolean = false): SVGSVGElement {
        let svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        //svg.setAttribute("preserveAspectRatio", "none");
        svg.setAttribute("viewBox", "0 0 42 42");
        svg.classList.add("a-svg");
        svg.classList.add("a-svg-bar");

        if (values && values.length > 0) {
            // get max value
            let max = 0;
            for (let value of values) {
                if (max < value.value) {
                    max = value.value;
                }
            }

            if (max > 0) {
                // factor and width per bar
                let factor = 40 / max;
                let width = 40 / values.length;
                let x = 0;
                for (let value of values) {
                    if (value.value > 0) {
                        svg.appendChild(this.createBar(x, value.className, value.value * factor, width));
                        if (showValues) {
                            svg.appendChild(this.createText(x, width, value.value));
                        }
                    }
                    x += width;
                }
            }
        }

        return svg;

    }

    createBar(x: number, className: string, height: number, width: number): SVGRectElement {
        let space = (width - (width * BAR_WIDTH)) / 2;
        width = width * BAR_WIDTH;

        let rect = document.createElementNS("http://www.w3.org/2000/svg", "rect");
        rect.setAttribute("x", (x + space).toString());
        rect.setAttribute("y", (41 - height).toString());
        rect.setAttribute("width", width.toString());
        rect.setAttribute("height", height.toString());
        rect.classList.add(className);

        let text = document.createElementNS("http://www.w3.org/2000/svg", "text");
        return rect;
    }

    createText(x: number, width: number, value: number): SVGTextElement {
        let text = document.createElementNS("http://www.w3.org/2000/svg", "text");
        text.setAttribute("text-anchor", "middle");
        text.classList.add("svg-bar-text");

        let tspan = document.createElementNS("http://www.w3.org/2000/svg", "tspan");
        tspan.setAttribute("x", (x + width / 2).toString());
        tspan.setAttribute("y", "40");
        tspan.innerHTML = value.toString();
        text.appendChild(tspan);

        return text;
    }
}